// extracted by mini-css-extract-plugin
export default {"root":"ConditionConfigDialog_root__f35WJ","switches":"ConditionConfigDialog_switches__z5KKB"};